<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h4 class="modal-card-title">
        Edit Delivery
        <span class="line-height has-text-dark required-label is-size-5 is-italic is-pulled-right mr-0 has-text-weight-normal">
            * required
        </span>
      </h4>
    </header>
    <section class="modal-card-body is-size-4 pt-0">
        <div class="column">
            <label class="label is-italic has-text-weight-semibold">Delivery Name</label>
            <textarea class="textarea" rows="2" v-model="name"></textarea>

            <label class="label is-italic mt-4 has-text-weight-semibold">Tracking Number</label>
            <textarea class="textarea" rows="3" v-model="trackingId"></textarea>
        </div>
       
    </section>
    <footer class="modal-card-foot is-justify-content-flex-end has-background-white">
      <button class="button is-outlined" @click="cancel()">Cancel</button>
      <button class="button is-dark"
              @click="save()" :disabled="disabled">Save</button>
      </footer>
  </div>
  <o-loading
      :full-page="false"
      :active="isLoading"
      :can-cancel="true"
    ></o-loading>
</template>
<script>
import {
  reactive, toRefs, computed
} from 'vue';
 import GeneralShippingMixin from '@/components/mixins/GeneralShippingMixin';

export default {
  props: {
    rowData: Object,
  },
  setup(props, { emit }) {
    const state = reactive({
      name: props.rowData.name,
      trackingId: _.get(props.rowData, 'delivery.trackingId', ''),
      isLoading: false
    });

    const { updateShipment } = GeneralShippingMixin();

    const disabled = computed(() => {
      return (
        state.name.length < 3 ||
        (state.name === props.rowData.name &&
        state.trackingId === _.get(props.rowData, 'delivery.trackingId', ''))
      );
    });
 
    const cancel = () => {
      emit('close');
    };

    const save = async() => {
        try {
            state.isLoading = true;
            _.set(props.rowData, 'name', state.name);
            _.set(props.rowData, 'delivery.trackingId', state.trackingId);
            await updateShipment(props.rowData);
        } catch (error) {
            console.log(error);
            return;
        } finally {
            state.isLoading = false;
        }
       cancel();
    }

    return {
      ...toRefs(state),
      cancel,
      disabled,
      save
    };
  },
};
</script>

<style scoped>
  .modal-card-body {
    overflow: visible;
  }
  .modal-card-head {
    background-color: #fff !important;
    border-bottom:0 !important;
  }
  .modal-card-foot {
    border-top: 1px solid #84888c;
  }
</style>
